import { SmartTagCheckboxFacet } from '@process-creative/slate-ajax-collection';
import { CLASS_COLOR } from '../../../tools/constants/classes';
import FilterUtils from '../../../utils/FilterUtils';
import { getColorValue } from '../../../config/colorMap';

export class CustomTagCheckboxFacet extends SmartTagCheckboxFacet {
  constructor(params) {
    super(params);
  }

  getCheckedSmartTagOptions() {
    return this.getCheckedOptions().map(o => this.getOptionName(o)).join(', ');
  }

  /**
   * Generate HTML for tag facet options with conditional styling
   * Material facets = checkboxes, Color facets = radio with color swatches
   */
  getPrint() {
    let options = this.getOptionsToDraw();
    let prefix = this.prefixes[0];
    let token = this.token[0];

    // Check if this is a color facet
    const isColorFacet = prefix && prefix.toLowerCase().includes('colour');

    let x = `<div class="c-collection-faceted-nav__facet-group" data-faceted-subnav>`;
    x += `<ul class="c-facets__list" role="list">`;
    options.forEach((option, i) => {
      let optionName = option.replace(`${prefix}${token}`, '');
      let checkboxId = `${prefix}-${i}`.replaceAll(' ', '-');
      
      // Get product count for this option
      const productCount = FilterUtils.getProductCountForTag(this.template.data.products || [], option);

      // Use checkbox styling for dynamic tags, color swatch for color facets
      const isCheckboxStyle = prefix && !prefix.toLowerCase().includes('colour');
      const listItemClass = isCheckboxStyle ? 'is-checkbox' : 'is-radio';
      const labelClass = isCheckboxStyle ? 'c-facets__checkbox' : 'c-facets__radio';
      const textClass = isCheckboxStyle ? 'c-facets__checkbox-text' : 'c-facets__radio-text';

      x += `<li 
            class="c-collection-faceted-nav__option ${listItemClass} o-heading--7 ${isColorFacet ? CLASS_COLOR : ''}"
            ${isColorFacet ? `style='--option-color: ${this.getColorValue(optionName)};'` : ''}
            data-option-label="${optionName}"
            data-faceted-check-item
          >
          <input
            type="checkbox"
            class="c-facets__input c-collection-faceted-nav__option-input ${listItemClass}"
            data-index="${i}" data-option="${this.template.escape(option)}" data-option-label="${optionName}"
            data-facet-checkbox ${this.isSelected(option) ? 'checked' : ''}
            id="${checkboxId}"
          />
          <label for="${checkboxId}" class="${labelClass} c-collection-faceted-nav__option-label">
            <span class="${textClass}">${optionName}</span>
            <span class="c-facets__option-count">(${productCount})</span>
          </label>
      </li>`;
    });
    x += `</ul></div>`;
    return x;
  }

  getColorValue(colorName) {
    // Use the centralized color mapping configuration
    return getColorValue(colorName);
  }
}